import { DailyRateService } from '../../service/daily-rate.service';
import { Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { ExportService } from 'src/app/features/transport-operation/services/export.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';

@Component({
  selector: 'laas-daily-rate-setting-add',
  templateUrl: './daily-rate-setting-add.component.html',
  styleUrls: ['./daily-rate-setting-add.component.scss']
})
export class DailyRateSettingAddComponent extends SessionBaseComponent implements OnInit {
  readonly permissionCode: string = PermissionConstants.ViewDailyRateSetting;
  isSearchFormOpen: boolean;
  isPermissionLoaded: boolean;

  //form
  addForm: FormGroup;
  dailyRate: any;
  submitted: boolean;

  //options
  dailyTypeOptions: any[];
  currencyOptions: any[];

  yearRange: any;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private facilityService: FacilityService,
    private dailyRateService: DailyRateService,
    private commonDataService: CommonDataService
  ) {
    super(injector);
    this.isSearchFormOpen = true;
    this.submitted = false;
    this.isPermissionLoaded = false;

    //options
    this.dailyTypeOptions = [];
    this.currencyOptions = [];

    this.yearRange = `${new Date().getFullYear() - 40}:${new Date().getFullYear() + 40}`;

    this.dailyRate = {
      rateType: 'CUSTOMS',
      dateDtTimeZone: '',
      fromCurrency: '',
      toCurrency: '',
      rate: null,
      rateYM: '',
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: '',
      isActivated: '1'
    };

    this.addForm = this.fb.group({
      rateType: 'CUSTOMS',
      dateDtTimeZone: ['', Validators.required],
      fromCurrency: ['', Validators.required],
      toCurrency: ['', Validators.required],
      rate: [null, Validators.required],
      rateYM: ['', Validators.required],
      createUser: '',
      createDt: '',
      updateUser: '',
      updateDt: '',
      isActivated: '1'
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    const canInPage = this.permissionCodes.includes(this.permissionCode) || this.userProfile.userType == UserType.SuperAdmin.toString();
    if (!canInPage) {
      return this.routeStateService.navigateTo('/Error/unAuthorize');
    }
    this.isPermissionLoaded = true;

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RateType').subscribe({
      next: result => {
        this.dailyTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.translateService.get('Common.Message.ChooseOption')
          .subscribe({
            next: msg => {
              this.currencyOptions.unshift({
                label: msg,
                value: ""
              });
            }
          });

      }
    });
  }

  saveBtn(event: any): void {
    this.submitted = true;

    if (this.addForm.invalid) {
      this.translateService.get('ExchangeRate.Alert.CheckRequiredFields')
          .subscribe({
            next: msg => {
              this.toastService.warn(msg);
            }
          });

      return;
    }

    //DateTime convert
    this.dailyRate.date = isNullOrEmpty(this.dailyRate.dateDtTimeZone) ? null : new Date(this.dailyRate.dateDtTimeZone).toISOString();
    this.dailyRate.updateUser = this.userProfile.userName;
    this.dailyRate.createUser = this.userProfile.userName;
    this.dailyRate.facility = this.laasSetting.facility;

    this.dailyRateService.addDailyRate(this.dailyRate).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
          .subscribe({
            next: msg => {
              this.toastService.success(msg);
              this.routeStateService.navigateTo('/Setting/DailyRateSetting', result);
            }
          });
      },
      error: err => {
        console.log(err);
        this.toastErrorMessage(err.error);
      }
    });
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }

  // convenience getter for easy access to form fields
  get f() { return this.addForm.controls; }


}
